if (window.fetch) {
    import ('./app').then(module => module.default());
} else {
    import('./polyfills').then(() => {
        import ('./app').then(module => module.default());
    });
}